import React from "react";
import { connect } from "react-redux";

import PendingSection from './PendingSection'
import Loader from "../../utils/Loader";

// State
import { userTokenUpdate, userLogout } from "../../../store/actions/user";
import { getRegisteredReviewers } from "../../../store/actions/registered";
import { setpageTitle } from "../../../store/actions/siteInfo";

class AdminPendingSection extends React.Component{
	constructor(props){
		super(props);
		this.state = {
			isLoading: 1
		}

		this.props.setpageTitle("Registered Reviewers");
	}

	componentDidMount() {
		this.loadData();
	}

	loadData(){
		this.props.getRegisteredReviewers();
		this.setState({isLoading: 0})
		return;
	}

    render(){
		const {registered} = this.props.registered;
		return(
		<React.Fragment>
			{this.state.isLoading ? (
				<div className="pt2 pb2">
					<Loader />
				</div>
			) : (
			<React.Fragment>
				<h1>Registered Reviewers</h1>
				{registered && (
					registered.map((item, i) => (
						
						<PendingSection 
							key={i}
							fname={item.fname}
							lname={item.lname}
							email={item.email}
							phone={item.phone}
							review_id={item.review_id}
							title={item.title}
							date={item.date_edited}
						/>
					))
				)}
				{registered && registered.length === 0 && (
					<div className="registered-empty">There are currently no registered reviewers!</div>
				)}
			</React.Fragment>
			)}
		</React.Fragment>
		)
    }
}

const mapStateToProps = state => ({
		registered: !!state.registered.registered ? state.registered.registered : [],
		isLoading: state.registered.inProcess,
	});


export default connect(
	mapStateToProps,
	{
		userTokenUpdate,
		userLogout,
		getRegisteredReviewers,
		setpageTitle
	}
)(AdminPendingSection);


// WEBPACK FOOTER //
// ./src/components/admin/pending/AdminPendingSection.js